<template>
    <div class="border-2 border-sky-500 shadow bg-white flex flex-col divide-y">
        <h2 class="p-4 text-2xl text-gray-700 font-semibold">Verify Your Email</h2>
        <div class="p-4 space-y-4">
            <div v-if="form.wasSuccessful" class="notification success">
                <div class="flex-1 text-center">Email was sent.</div>
            </div>

            <div v-if="form.tooManyAttempts" class="notification danger">
                <div class="flex-1 text-center">Too many attempts. Please try again later.</div>
            </div>
            <div class="space-y-4 flex-1 font-semibold text-lg text-gray-700">
                <div>Before you can publish your job post, you need to verify your email.</div>
                <div>We sent you an email when you signed up that has a link to verify your email.</div>
                <div>If you need another email, we can send you one by clicking the email button.</div>
            </div>
        </div>
        <div class="p-4">
            <loading-button @click.prevent="sendVerifyEmail" :loading="form.processing" class="btn btn-green w-full sm:ml-auto sm:w-32">Email</loading-button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import useForm from '@/functions/useForm';

const form = useForm({})

const props = defineProps({
    url: {
        type: String,
        default: true,
    }
})

const show = ref(false)

const toggle = () => show.value = !show.value

const sendVerifyEmail = () => form.post(props.url)

watch(show, () => {
    form.wasSuccessful = false
    form.tooManyAttempts = false
})
</script>
